module.exports = global["punycode"] = require("-!./punycode.js");